import React, {Fragment} from 'react';
import ScheduleApi from "../../apis/ScheduleApi";
import {NotificationManager} from "react-notifications";
import {connect} from "react-redux";
import {getSchedule} from "../../actions/scheduleAction";
import {translate} from "react-i18next";
import {MenuItem, Modal} from "react-bootstrap";

class DeleteShifts extends React.Component {

    state = {
        isOpen: false,
        loading: false
    };

    open = () => {
        this.setState({
            isOpen: true
        });
    };

    close = () => {
        this.setState({
            isOpen: false
        });
    };

    handleSubmit = (e) => {
        const { t, getSchedule } = this.props;
        e.preventDefault();
        this.setState({
            loading: true
        });
        ScheduleApi.deleteShifts()
            .then((response) => {
                this.setState({
                    loading: false
                });
                if(response.status === 200 && response.data.success) {
                    NotificationManager.success(t('schedule.deleteShifts.delete.success'), t('default.notification.action.success'), 5000);
                    getSchedule();
                    this.close();
                } else {
                    NotificationManager.error(t('schedule.deleteShifts.delete.error'), t('default.notification.action.error'), 5000);
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false
                });
                NotificationManager.error(t('schedule.deleteShifts.delete.error'), t('default.notification.action.error'), 5000);
            });
    };

    render() {
        const {t} = this.props;
        return (
            <Fragment>
                <MenuItem onClick={this.open}>
                    {t('schedule.buttons.deleteShifts')}
                </MenuItem>
                <Modal show={this.state.isOpen} onHide={this.close} dialogClassName="inmodal">
                    <Modal.Header closeButton>
                        <Modal.Title>{t('schedule.deleteShifts.title')}</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={this.handleSubmit}>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-xs-12">
                                    <label>
                                        {t('schedule.deleteShifts.text.warning')}
                                    </label>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-default" onClick={this.close} type="button">
                                {t('default.cancel')}
                            </button>
                            <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                ) : null}
                                {t('default.save')}
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </Fragment>
        )
    }

}

export default connect(null, { getSchedule })(translate()(DeleteShifts));
